const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/rapporter/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { type SubmitHandler } from "react-hook-form";
export const Route = createFileRoute("/_authenticated-user/superuser/rapporter/")({
  head: () => ({
    meta: [{
      title: "Superuser statistikk | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});